import React from "react";
import { SourcesHistoryContainer } from "../../../containers";

const SourcesHistory = (props) => {
  return <SourcesHistoryContainer {...props} />;
};

export default SourcesHistory;
